import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "4"
    }, [
      _createElementVNode("path", { d: "m42 42-2.286-5M26 42l2.286-5m0 0L34 24l5.714 13m-11.428 0h11.428M16 6l1 3M6 11h22M10 16s1.79 6.26 6.263 9.74C20.737 29.216 28 32 28 32" }),
      _createElementVNode("path", { d: "M24 11s-1.79 8.217-6.263 12.783C13.263 28.348 6 32 6 32" })
    ], -1)
  ])))
}
export default { render: render }